import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const reviewChecklistServices = {
  getReviewChecklistData,
  addNewReviewChecklist,
  updateReviewChecklist,
  softDeleteRestoreReviewChecklist,
  deleteReviewChecklistData,
};

async function addNewReviewChecklist(userData) {
  const response = await fetch(
    `${config.API_URL}addNewReviewChecklist`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateReviewChecklist(userData) {
  const response = await fetch(
    `${config.API_URL}updateReviewChecklist`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreReviewChecklist(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreReviewChecklist`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteReviewChecklistData(userData) {
  const response = await fetch(
    `${config.API_URL}deleteReviewChecklistData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getReviewChecklistData(status, moduleType, searchData, page, length) {
  const query = new URLSearchParams();
  query.append("search", searchData || "");
  if (moduleType) query.append("moduleType", moduleType);
  if (page && length) {
    query.append("page", page);
    query.append("length", length);
  }

  const response = await fetch(
    `${config.API_URL}getReviewChecklistData/${status}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );

  const data = await response.json();
  return data;
}
